export default "__VITE_ASSET__DerVOuYm__"